<template>
    <div>
        <vue-query-builder
            :rules="rules"
            v-model="query"
            :maxDepth="9"
            :labels="labels"
        > </vue-query-builder>

        <p>Generated output:</p>

        <pre>{{ JSON.stringify(this.query, null, 2) }}</pre>
    </div>
</template>

<script>
import VueQueryBuilder from "vue-query-builder";
import 'vue-query-builder/dist/VueQueryBuilder.css'

export default {
    name: "App",
    components: {
        VueQueryBuilder
    },

    data() {
        return {
            rules: [
                {
                    type: "text",
                    id: "title",
                    label: "Título"
                },
                {
                    type: "text",
                    id: "body",
                    label: "Texto"
                },
                {
                    type: "text",
                    id: "user.name",
                    label: "Autor"
                },
                {
                    type: "select",
                    id: "tag.name",
                    label: "Tag",
                    choices: [
                        { label: "Database", value: "database" },
                        { label: "Storage", value: "storage" },
                    ]
                }
            ],

            labels: {
                matchType: "Operador",
                matchTypes: [
                    {id: "all", label: "E"},
                    {id: "any", label: "Ou"}
                ],
                addRule: "Adicionar regra",
                removeRule: "&times;",
                addGroup: "Adicionar grupo",
                removeGroup: "&times;",
                textInputPlaceholder: "Valor",
            },

            query: {
                logicalOperator: "all",
                children: []
            }
        };
    }
};
</script>

<style>
.vqb-group-body .vqb-children {
    margin-left: 15px;
}
</style>
